// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__Y4Opp","left":"StickyBox_left__bPeh3","right":"StickyBox_right__2HT5I"};